module.exports = __webpack_public_path__ + "img/zuixintougao.72121784.png";